export default {
    resend_dealer_alert_log_title: "Resend Alert to Webhook",
    resend_dealer_alert_log_description: "Are you sure you want to resend this alert to the configured webhook?",
    resend_dealer_alert_log_log_id: "Log ID",
    resend_dealer_alert_log_timestamp: "Timestamp",
    resend_dealer_alert_log_resend: "Resend",
    resend_dealer_alert_log_success: "Alert resent successfully to webhook",
    resend_dealer_alert_log_error: "Failed to resend alert to webhook. Please check if the webhook is inactive, was deleted, or misconfigured.",
};
